var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "youtube-_168_",
    "data-name": "youtube-[#168]",
    className: "cls-1",
    d: "M319.54,383.43v-224.47c79.69,37.5,141.41,73.73,214.4,112.77-60.2,33.4-134.71,70.84-214.4,111.7M763.64,47.32c-13.75-18.12-37.18-32.21-62.12-36.88C628.21-3.46,170.84-3.5,97.57,10.44c-20,3.75-37.81,12.81-53.11,26.89C-20.01,97.18.19,418.06,15.73,470.03c6.53,22.5,14.98,38.73,25.62,49.38,13.71,14.08,32.47,23.79,54.03,28.12,60.36,12.5,371.35,19.47,604.87,1.88,21.52-3.75,40.56-13.75,55.58-28.44,59.61-59.59,55.54-398.52,7.81-473.65"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c75f01381de20d1db163953992b7a8d6.svg";
export { ForwardRef as ReactComponent };